import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { localTenantHosts } from "./localTenants";
import type { SiteConfig } from "../../lib/gboModels";

export type TenantState = {
  localTenantHost: string;
  currentSiteConfig: SiteConfig | null;
};

const initialState: TenantState = {
  localTenantHost: localTenantHosts[0],
  currentSiteConfig: null,
};

export const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    localTenantChanged(state, action: PayloadAction<string>) {
      state.localTenantHost = action.payload;
      state.currentSiteConfig = null;
    },
    siteConfigLoaded(state, action: PayloadAction<SiteConfig>) {
      state.currentSiteConfig = action.payload;
    },
  },
});

export const { localTenantChanged, siteConfigLoaded } = tenantSlice.actions;
export const tenantReducer = tenantSlice.reducer;
